import React from 'react';
import { DialogDelete } from 'shared/ui/Dialog';
import { useDeleteParticipantMutation } from 'features/deleteParticipant/api/deleteParticipantApi';

type DeleteDialogParticipantPropsType = {
  promoId: string;
  deleteId: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DeleteDialogParticipant = ({ promoId, deleteId, open, setOpen }: DeleteDialogParticipantPropsType) => {
  const [deleteParticipantRequest] = useDeleteParticipantMutation();

  const onSubmit = () => {
    deleteParticipantRequest({
      id: promoId,
      body: {
        participant_id: deleteId,
      },
    });
  };

  return (
    <DialogDelete
      title="Вы действительно хотите удалить торговую точку?"
      open={open}
      setOpen={setOpen}
      onConfirm={onSubmit}
    />
  );
};
